import { useContext } from "react"
import { rootContext } from "../contexts/rootContext"
import guard from "../images/stop.png"
import popperBackground from "../images/popperBackground.jpg"
import popperBorder from "../images/popperBorder.jpg"
import popperCorner from "../images/popperCorner.jpg"


export const Guard = () => {
  const context = useContext(rootContext)

  return (<div 
      style={{
          color: context.theme.text.primary,
          position: "absolute",
          top: "0",
          animationName: "guardAnimation",
          animationDuration: "5s",
          animationDelay: "0s",
          animationIterationCount: "1",
          animationFillMode: "forwards",
          animationTimingFunction: "linear",
          userSelect: "none",
          // @ts-ignore
          "WebkitUserDrag": "none"
        }}
    >
      <img src={guard} style={{ marginLeft: "10px" }} />
      {/*
      
      ------- CORNERS -------

      */}
      <div 
        style={{
          zIndex: "99",
          position: "absolute",
          left: "210px",
          top: "268px",
          height: `15px`,
          width: `15px`,
          backgroundImage: `url(${popperCorner})`,
          backgroundSize: "contain"
        }}
      />
      <div 
        style={{
          zIndex: "99",
          position: "absolute",
          left: "-5px",
          top: "268px",
          height: `15px`,
          width: `15px`,
          backgroundImage: `url(${popperCorner})`,
          backgroundSize: "contain",
          transform: "rotate(90deg)"
        }}
      />
      <div 
        style={{
          zIndex: "99",
          position: "absolute",
          left: "-5px",
          top: "198px",
          height: `15px`,
          width: `15px`,
          backgroundImage: `url(${popperCorner})`,
          backgroundSize: "contain",
          transform: "rotate(180deg)"
        }}
      />
      <div 
        style={{
          zIndex: "99",
          position: "absolute",
          left: "210px",
          top: "198px",
          height: `15px`,
          width: `15px`,
          backgroundImage: `url(${popperCorner})`,
          backgroundSize: "contain",
          transform: "rotate(270deg)"
        }}
      />
      {/*
      
      ------- CORNERS -------

      */}
      {/*
      
      ------- BORDERS -------

      */}
      <div 
        style={{
          position: "absolute",
          top: "202px",
          left: "210px",
          height: `78px`,
          width: `15px`,
          backgroundImage: `url(${popperBorder})`,
          backgroundSize: "contain"
        }}
      />
      <div 
        style={{
          position: "absolute",
          top: "105px",
          left: "102px",
          height: `202px`,
          width: `15px`,
          backgroundImage: `url(${popperBorder})`,
          transform: "rotate(90deg)",
          backgroundSize: "contain"
        }}
      />
      <div 
        style={{
          position: "absolute",
          top: "201px",
          left: "-5px",
          height: `78px`,
          width: `15px`,
          backgroundImage: `url(${popperBorder})`,
          transform: "rotate(180deg)",
          backgroundSize: "contain"
        }}
      />
      <div 
        style={{
          position: "absolute",
          top: "174px",
          left: "102px",
          height: `202px`,
          width: `15px`,
          backgroundImage: `url(${popperBorder})`,
          transform: "rotate(270deg)",
          backgroundSize: "contain"
        }}
      />
      {/*
      
      ------- BORDERS -------

      */}
      <div
        style={{
          width: "190px",
          height: "45px",
          padding: "5px",
          marginTop: "5px",
          marginLeft: "10px",
          backgroundImage: `url(${popperBackground})`,
          fontFamily: "MyFont",
          color: "rgb(119 75 53)"
        }}
      >
        <span>Stop!</span><br/> You have violated the law!
      </div>
    </div>)
}
